// extracted by mini-css-extract-plugin
module.exports = {"knockButton":"KnockButton_knockButton__3wY_K"};